module.exports = __webpack_public_path__ + "img/05.2f4f9e52.png";